import React from 'react'
import Footer from '../components/Footer'
import FAQ from '../components/Home/FAQ'
import OurApp from '../components/Home/OurApp'
import FindSamoolah from '../components/Services/FindSamoolah'
import EverythingGuaranteed from '../components/Services/EverythingGuaranteed'
import Steps from '../components/Home/Steps'
import MainServices from '../components/Services/MainServices'
import Service from '../components/Services/Service'
import "../styles/services.css"
import Navbar from '../components/Navbar'

const Services = () => {
  return (
    <div>
      <Navbar />
      <MainServices />
      <Service />
      <EverythingGuaranteed />
      <FindSamoolah />
      <OurApp />
      <FAQ />
      <Footer />
    </div>
  )
}

export default Services